// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__AYuGQ","footer":"ChangeClinic_footer__8co3R"};